module.exports = __webpack_public_path__ + "static/transparency_bn@2x-b3c97ac0c07d910987332d55f356b800.png";